(function($) {
  $.fn.calculatePlanUpgradePrice = function (minAccessLevel, currentPlanFrequency, currency) {
    const priceObj = {};

    if (currentPlanFrequency === 'yearly') {
      priceObj.readablePlanFrequency = 'per year';

      if (currency === 'GBP') {
        switch (minAccessLevel) {
          case 'paid_player':
            priceObj.changePlanPrice = '£10';
            break;

          case 'coach_rec':
            priceObj.changePlanPrice = '£36';
            break;

          case 'coach_team':
            priceObj.changePlanPrice = '£60';
            break;

          case 'coach_club':
            priceObj.changePlanPrice = '£240';
            break;

          case 'standard':
            priceObj.changePlanPrice = '£36';
            break;

          case 'premium':
            priceObj.changePlanPrice = '£60';
            break;

          case 'enterprise':
            priceObj.changePlanPrice = '£240';
            break;
          // no default
        }
      } else if (currency === 'USD') {
        switch (minAccessLevel) {
          case 'paid_player':
            priceObj.changePlanPrice = '$10';
            break;

          case 'coach_rec':
            priceObj.changePlanPrice = '$48';
            break;

          case 'coach_team':
            priceObj.changePlanPrice = '$84';
            break;

          case 'coach_club':
            priceObj.changePlanPrice = '$275';
            break;

          case 'standard':
            priceObj.changePlanPrice = '$48';
            break;

          case 'premium':
            priceObj.changePlanPrice = '$84';
            break;

          case 'enterprise':
            priceObj.changePlanPrice = '$275';
            break;
          // no default
        }
      }
    } else if (currentPlanFrequency === 'monthly') {
      priceObj.readablePlanFrequency = 'per month';

      if (currency === 'GBP') {
        switch (minAccessLevel) {
          case 'paid_player':
            priceObj.changePlanPrice = '£1';
            break;

          case 'coach_rec':
            priceObj.changePlanPrice = '£4';
            break;

          case 'coach_team':
            priceObj.changePlanPrice = '£6';
            break;

          case 'coach_club':
            priceObj.changePlanPrice = '£25';
            break;

          case 'standard':
            priceObj.changePlanPrice = '£4';
            break;

          case 'premium':
            priceObj.changePlanPrice = '£6';
            break;

          case 'enterprise':
            priceObj.changePlanPrice = '£25';
            break;
          // no default
        }
      } else if (currency === 'USD') {
        switch (minAccessLevel) {
          case 'paid_player':
            priceObj.changePlanPrice = '$1';
            break;

          case 'coach_rec':
            priceObj.changePlanPrice = '$5';
            break;

          case 'coach_team':
            priceObj.changePlanPrice = '$8';
            break;

          case 'coach_club':
            priceObj.changePlanPrice = '$25';
            break;

          case 'standard':
            priceObj.changePlanPrice = '$5';
            break;

          case 'premium':
            priceObj.changePlanPrice = '$8';
            break;

          case 'enterprise':
            priceObj.changePlanPrice = '$25';
            break;
          // no default
        }
      }
    }
    return priceObj;
  };
}(jQuery));



// WEBPACK FOOTER //
// ./library/js/plugins/calculate-plan-upgrade-price.js